import type { AgentSessionListItem, ChatRowAction } from '../agent'
import { refuse, type WhoToAsk } from './permissionReason'

/**
 * Why the person can't rename, star or delete a chat in the History list, or
 * undefined when they can. The server lets only the owner rename and star
 * (agent_manage.go); delete is for the owner or a Manager (agent_authz.go).
 * There is no way to copy a colleague's chat, so no refusal offers one.
 */
export function chatActionReason(who: WhoToAsk, currentUserEmail: string | undefined, isManager: boolean) {
  return (action: ChatRowAction, s: AgentSessionListItem): string | undefined => {
    const owns = !!currentUserEmail && s.user_email.toLowerCase() === currentUserEmail.toLowerCase()
    if (owns) return undefined
    switch (action) {
      case 'delete':
        return isManager ? undefined : refuse("You can't delete this chat.", who, { owner: s.user_email }).reason
      case 'rename':
        return refuse("You can't rename this chat.", who, { owner: s.user_email }).reason
      case 'star':
        // A star marks a chat for its owner; nobody else can ask for one.
        return "You can't star a colleague's chat. Stars are for your own chats."
    }
  }
}
